import * as S from "./styles";
import { StepCard } from "./assets/StepCard";
import { steps } from "./static";
import { Button } from "../../components/common/Button";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import React, { useEffect, useState } from "react";
import { ButtonWrapper } from "./styles";
import { createNewWallet } from "../Wallets/api";
import posthog from "posthog-js";
import { allWallets } from "../Wallets/redux/slice";
import Loader from "../../components/common/Loader";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { FEATURE_FLAG_KEYS } from "../../utils/featureFlags";
import { appRoutes } from "../../app/router/utils";

const ChinaPayoutGuide = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { wallets } = useAppSelector((state) => state?.wallets);
  const [loading, setLoading] = useState(false);

  const { userId, businessId } = useAppSelector((state) => state?.users);
  const { business } = useAppSelector((state) => state.settings);
  const enableChinaPayoutV2 = useFeatureFlagEnabled(FEATURE_FLAG_KEYS.enableChinaPayoutV2);
  const enableNgnChinaPayout = useFeatureFlagEnabled(
    FEATURE_FLAG_KEYS.enableNgnChinaPayout,
  );

  const MERCHANT_USD = wallets?.find((wallet) => wallet?.currency === "USD");
  const MERCHANT_NGN = wallets?.find((wallet) => wallet?.currency === "NGN");
  const hasFundingWallet = Boolean(
    MERCHANT_USD || (enableNgnChinaPayout && MERCHANT_NGN),
  );

  const NAVIGATE_URL = enableChinaPayoutV2
    ? appRoutes.cnyPayoutv2()
    : appRoutes.cnyPayout();

  const handleGetStarted = async () => {
    try {
      setLoading(true);

      if (hasFundingWallet) {
        navigate(NAVIGATE_URL);
      } else {
        await createNewWallet({
          businessId,
          userId,
          currency: "USD",
        })
          .then(() => {
            posthog?.capture("create_wallet_b2b", {
              status: "success",
              currency: "USD",
            });
          })
          .then(() => {
            navigate("/wallets/");
          });
      }
    } catch (error) {
      posthog?.capture("create_wallet_b2b", {
        status: "error",
        currency: "USD",
        message: error?.message,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (businessId) {
      dispatch(allWallets({ businessId }));
    }
  }, [businessId]);

  return (
    <S.Container>
      <Loader isLoading={loading} />
      <React.Fragment>
        <S.Heading>How to Payout to a China Account</S.Heading>
        <S.Paragraph>
          Send Payments from Africa to China bank accounts and wallets.
        </S.Paragraph>
      </React.Fragment>

      <S.CardsContainer>
        {steps.map((step) => (
          <StepCard key={step.number} {...step} />
        ))}
      </S.CardsContainer>

      <ButtonWrapper>
        <Button
          theme={"secondary"}
          height={"50px"}
          fontSize={"16"}
          onClick={handleGetStarted}
          disabled={!business?.approved}
        >
          Get Started
        </Button>
      </ButtonWrapper>
    </S.Container>
  );
};

export default ChinaPayoutGuide;
